var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$parent.user.group)?_c('div',{staticClass:"wrapper",class:[
    { 'nav-open': _vm.$sidebar.showSidebar },
    { rtl: _vm.$route.meta.rtlActive } ]},[_c('notifications'),_c('side-bar',{attrs:{"active-color":_vm.sidebarBackground,"background-image":_vm.sidebarBackgroundImage,"data-background-color":_vm.sidebarBackgroundColor}},[_c('user-menu',{attrs:{"title":_vm.userFullName,"avatar":_vm.getAvatar}}),_c('mobile-menu'),_c('template',{slot:"links"},[(_vm.$parent.user.group.permissions.offers)?_c('sidebar-item',{attrs:{"link":{ name: 'Kalkulacije', icon: 'article', path: '/files' }}}):_vm._e(),(_vm.$parent.user.group.permissions.offers)?_c('sidebar-item',{attrs:{"link":{
          name: 'Radni nalozi',
          icon: 'fact_check',
          path: '/files?filter=confirmed',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.offers)?_c('sidebar-item',{attrs:{"link":{
          name: 'Ponude',
          icon: 'sticky_note_2',
          path: '/offers',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.offers)?_c('sidebar-item',{attrs:{"link":{
          name: 'Tabačna štampa',
          icon: 'border_color',
          path: '/job',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.clients)?_c('sidebar-item',{attrs:{"link":{ name: 'Klijenti', icon: 'people', path: '/clients' }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Magacin',
          icon: 'inventory_2',
          path: '/inventory',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Izlazne fakture',
          icon: 'arrow_forward',
          path: '/invoices',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Ulazne fakture',
          icon: 'arrow_back',
          path: '/expenses',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Plate',
          icon: 'euro_symbol',
          path: '/expenses?filter=salary',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Računovodstvo',
          icon: 'account_balance',
          path: '/accounting',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Transakcije',
          icon: 'rule',
          path: '/transactions',
        }}}):_vm._e(),(_vm.$parent.user.group.permissions.users)?_c('sidebar-item',{attrs:{"link":{ name: 'Korisnici', icon: 'groups', path: '/users' }}}):_vm._e(),(_vm.$parent.user.group.permissions.expenses)?_c('sidebar-item',{attrs:{"link":{
          name: 'Materijali',
          icon: 'hexagon',
          path: '/materials',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{ name: 'Alatke', icon: 'build' }}},[_c('sidebar-item',{attrs:{"link":{ name: 'Blagajna ulaz', path: '/expenses?filter=cash' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Blagajna izlaz', path: '/invoices?filter=cash' }}}),_c('sidebar-item',{attrs:{"link":{ name: 'Blagajna stanja', path: '/accounting?filter=cash' }}})],1)],1)],2),_c('div',{staticClass:"main-panel"},[(_vm.$root.window.width <= 992)?_c('top-navbar'):_vm._e(),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }